import styled from 'styled-components';
import { Box } from '@mui/material';

export const IconBox = styled(Box)<{ $width?: string }>`
  white-space: nowrap;
  ${(props) => props.$width && `width: ${props.$width};`}
  margin-left: -1rem;
`;
